import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["lat", "lon"];

  declare readonly latTarget: HTMLInputElement;
  declare readonly lonTarget: HTMLInputElement;
  declare readonly hasLatTarget: boolean;
  declare readonly hasLonTarget: boolean;

  connect() {
    this.getLocation();
  }

  getLocation() {
    if (!this.hasLatTarget || !this.hasLonTarget) return;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.onSuccess.bind(this), this.onError.bind(this));
    }
  }

  private onSuccess(position: GeolocationPosition) {
    const { latitude, longitude } = position.coords;

    if (this.hasLatTarget) {
      this.latTarget.value = latitude.toString();
    }

    if (this.hasLonTarget) {
      this.lonTarget.value = longitude.toString();
    }
  }

  private onError() {
    alert("現在地の近くにある重機を探すためには、お使いのブラウザの設定を確認して現在地情報の共有を許可してください");
  }
}
